import { Location } from '@angular/common';
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatStepper } from "@angular/material/stepper";
import { Router } from "@angular/router";
import { catchError, combineLatest, filter, forkJoin, last, map, Observable, of, race, Subject, switchMap, take, takeUntil, takeWhile, timer } from "rxjs";
import { AlertService } from "src/app/components/alert/alert.service";
import { FONDO_GESTIONE_SEPARATA_LABEL, IOperationFilter } from 'src/app/modules/shared/models/policy.model';
import { EDashboardStatus, TDashboardStatus } from "src/app/pages/dashboard/dashboard.constants";
import { DashboardService } from "src/app/pages/dashboard/dashboard.service";
import { SearchService } from 'src/app/pages/search/search.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { LoggerService } from "src/app/services/logger.service";
import { SpinnerService } from "src/app/services/spinner.service";
import { AthoraPayloadUtils } from "src/app/utils/AthoraPayloadUtils";
import { CommonUtils } from "src/app/utils/CommonUtils";
import { FormUtils } from "src/app/utils/FormUtils";
import { PolicyService } from "../policy/policy.service";
import { BasicModalComponent } from "../shared/components/basic-modal/basic-modal.component";
import { BACK_BUTTON, BACK_TO_POLICY_BUTTON, CLOSE_BUTTON, CONFIRM_BUTTON, EModalOutput, NO_BUTTON, YES_BUTTON } from "../shared/components/basic-modal/basic-modal.constants";
import { frequency_premium_change_form_template, frequency_premium_change_form_validators, IVariazionePremioPeriodicitaRequest } from "../shared/components/frequency-premium-change/frequency-premium-change.constants";
import { ILiquidazioneScadenzaRequest, liquidation_maturity_form_template, liquidation_maturity_form_validators } from '../shared/components/liquidation-maturity/liquidation-maturity.constants';
import { IAnagrafica, ndg_variation_form_template, ndg_variation_form_validators } from "../shared/components/ndg-variation/ndg-variation.constants";
import { IRiattivazionePagamentiRequest } from "../shared/components/premium-payment-reactivation/premium-payment-reactivation.constants";
import { ISospensionePagamentiRequest } from "../shared/components/premium-payment-suspension/premium-payment-suspension.constants";
import { IRiscattoTotaleRequest, total_redeem_form_template, total_redeem_form_validators } from "../shared/components/total-redeem/total-redeem.constants";
import { EFormType, ERadioValue, IFormKey, IFormSelectOption } from "../shared/models/forms";
import { CONSTRAINT_EQUAL, CONSTRAINT_GREATER, CONSTRAINT_GREATER_OR_EQUAL, CONSTRAINT_LESSER, CONSTRAINT_LESSER_OR_EQUAL, CONSTRAINT_MESSAGE_1, IConstraint, IDraft, IDraftItem, IFilledQuestionnaire, IOperationConstraint, IProductConstraint, IQuestion, IQuestionnaire, IQuestionnaireAnswers } from "../shared/models/operation.model";
import { IBeneficiary, IBeneficiaryObject, ICityObject, ICountriesObject, IPolicyAsset, IProvinceObject } from "../shared/models/policy.model";
import { ALL_PRODUCTS_WITH_FUNDS, CANCEL_OPERATIONS, COD_COLLEGAMENTI_ATTIVI_AMMESSI, EOperationStep, EProductType, ERR_DOC_RETRIEVE_MESSAGE, ERROR_DOWNLOADING_DOC_MESSAGE, ICancelDocument, ICompanyDocumentResponse, IDocument, IIbanObject, ILifeFund, IOperationPayment, ISwitchRamiRequest, ISwitchRequest, MIN_VAGG_AMOUNT_FOR_QUESTIONNAIRE, MULTISOLUTION_PRODUCTS, MULTISTRATEGY_PRODUCTS, OPERATINS_WITHOUT_CONFIRM_MODAL, OPERATIONS_CHANGE_NDG, OPERATIONS_WITH_FREQUENCY, OPERATIONS_WITH_IBAN, TOperationStep, UNIT_PRODUCTS } from "./athora.constants";
import { AthoraService } from "./athora.service";
import { IVersamentoAggiuntivoRequest, payment_form_template, payment_form_validators } from "./components/additional-payment/additional-payment.constants";
import { address_change_form_template, address_change_form_validators, IAddress, IVariazioneRecapitoRequest } from "./components/address-change/address-change.constants";
import { bank_account_update_form_template, bank_account_update_form_validators, IVariazioneModPagamentoRequest } from "./components/bank-account-update/bank-account-update.constants";
import { IVariazioneBeneficiariRequest } from "./components/beneficiary-change/beneficiary-change.constants";
import { divestment_form_template, divestment_form_validators } from "./components/branch-switch-divestment/branch-switch-divestment.constants";
import { BranchSwitchInvestmentComponent } from "./components/branch-switch-investment/branch-switch-investment.component";
import { investment_form_template, investment_form_validators } from './components/branch-switch-investment/branch-switch-investment.constants';
import { IAnnulloOperazione } from "./components/cancel-operation/cancel-operation.constants";
import { claim_notification_form_template, claim_notification_form_validators, IComunicazioneSinistroRequest } from "./components/claim-notification/claim-notification.constants";
import { contractor_variation_form_template, contractor_variation_form_validators, IBodyVariazioneContraenza, ISubjectPersonaFisica, ISubjectPersonaGiuridica, subject_form_template, subject_form_validators } from "./components/contractor-variation/contractor-variation.constants";
import { IUploadDocumentObj } from "./components/document-upload/document-upload.constants";
import { IRiscattoParzialeRequest, partial_redeem_form_template, partial_redeem_form_validators } from "./components/partial-redeem/partial-redeem.constants";
import { single_step_branch_form_template, single_step_branch_form_validators } from "./components/single-step-branch-switch/single-step-branch-switch.constants";
import { SubjectPfInsertFormComponent } from './components/subject-pf-insert-form/subject-pf-insert-form.component';

@Component({
  selector: 'app-athora',
  templateUrl: './athora.component.html',
  styleUrl: './athora.component.scss',
})
export class AthoraComponent implements OnInit, AfterViewChecked, OnDestroy {

  operationsNamesList: IOperationFilter[];
  ndgVariationForm: FormGroup;
  firstStepForm: FormGroup;
  secondStepForm: FormGroup;
  searchForm: FormGroup;
  contractorAddressForm: FormGroup;
  questionnaireForm: FormGroup;
  questionnaireFormKeys: IFormKey[] = [];
  questionnaire: IQuestionnaire = null;
  questionnairesArray: IFilledQuestionnaire[] = [];
  retrievedQuestionnaires: any[];
  documentsList: any[];
  cancelDocsInfo: any[];
  frequencies: string[];
  ibanList: IIbanObject[];
  ndgVariationList: IAnagrafica[];
  countriesList: IFormSelectOption[];
  provincesList: IFormSelectOption[];
  citiesList: IFormSelectOption[];
  searchedSubject: IAnagrafica;
  operationStatus: TDashboardStatus = null;
  selectedIndex = 0;
  loadingCompleted = false;
  loadingStepperCompleted: boolean = false;
  policyAssets: IPolicyAsset[] = [];
  funds: IPolicyAsset[] = [];
  beneficiariesList: IBeneficiaryObject[];
  cancelFirstStepActive: boolean = true;
  customerHasTutor: boolean;
  errorRetrievingDocs: boolean = false;
  movementId: string = null;
  simulateOperation: boolean = false;
  operationHasError: boolean = false;
  operationErrorDescription: string;
  newLiquidationSubjects: Record<
    string,
    {
      rawFormOutcome: Record<string, any>;
      mappedOutcome: Record<string, any>;
    }
  > = {};
  loadAsset$ = new Subject<boolean>();
  destroy$ = new Subject();

  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('branchSwitchInvestment') branchSwitchInvestmentComponent: BranchSwitchInvestmentComponent;

  constructor(
    private readonly _policyService: PolicyService,
    private readonly _athoraService: AthoraService,
    private readonly _searchService: SearchService,
    private readonly _dashboardService: DashboardService,
    private readonly _spinnerService: SpinnerService,
    private readonly _dialog: MatDialog,
    private readonly _alertService: AlertService,
    private readonly _router: Router,
    private readonly _authService: AuthenticationService,
    private readonly _location: Location
  ) {}

  ngOnInit(): void {
    this.watchDetail();
    this.watchDescribe();
    this.watchAddressLists();
    this.manageDocs();
  }

  ngAfterViewChecked(): void {
    if (!this.loadingStepperCompleted) {
      if (this.stepper) {
        this.manageStepper();
        this.loadingStepperCompleted = true;
      }
      window.scrollTo(0, (window.document.body.scrollHeight - window.innerHeight));
    }
  }

  manageStepper(): void {
    for (let i = 0; i < this.selectedIndex; i++) {
      const step = this.stepper.steps.toArray()[i];
      step.completed = true;
    }
  }

  watchDetail(): void {
    this._policyService.detailLoadedObs
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          if (
            this.operationId.includes('SWIT') &&
            MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])
          ) {
            return this.openBackToPolicyModal();
          }
          this.createForm();
          const state = this._location.getState();
          if (state) {
            this.simulateOperation = CommonUtils.checkAndGet(state, 'simulateOperation', null);
            this.movementId = CommonUtils.checkAndGet(state, 'element.movementId', null);
            if (localStorage.getItem('movementId')) {
              this.movementId = localStorage.getItem('movementId');
            }
            else {
              localStorage.setItem('movementId', this.movementId);
            }
          }
          this.getDraft();
        }
      })
  }

  watchAddressLists(): void {
    this._athoraService.retrieveProvices
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.retrieveProvinces();
      })

    this._athoraService.retrievePlaces
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.retrieveCities(value);
      })
  }

  manageDocs(): void {
    this.subscribeToRetrieveDocuments();
    this.subscribeToRetrieveDownloadInfo();
    this.subscribeToDownloadDoc();
    this.subscribeToUploadDoc();
    if (this.isCancelOperation) {
      this.subscribeToDownloadDocRetry();
    }
  }

  subscribeToRetrieveDocuments(): void {
    this._policyService.retireveDocumentsSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.retrieveDocuments();
      })
  }

  subscribeToRetrieveDownloadInfo(): void {
    this._policyService.retireveDownloadInfoSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((document: any) => {
        if (document && !this.isCancelOperation) {
          this.documentsList.forEach(doc => {
            if (doc?.descrizioneDocumento === document?.descrizioneDocumento) {
              doc.isDownloading = true;
            }
          });
          this.documentsList = [...this.documentsList];
          this.startPolling(document);
        } else {
          this.manageCancelDoc(document);
        }
      })
  }

  subscribeToDownloadDoc(): void {
    this._policyService.documentDownloadSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((document: IDocument) => {
        if (document) {
          this.downloadDocument(document);
        }
      })
  }

  subscribeToDownloadDocRetry(): void {
    this._athoraService.downloadDocRetrySubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: boolean) => {
        if (value && this.cancelDocsInfo) {
          this.cancelDocsInfo.forEach(doc => {
            this.retrieveCancelDocument(doc);
          })
        }
      })
  }

  subscribeToUploadDoc(): void {
    this._policyService.documentUploadSubscription
      .pipe(takeUntil(this.destroy$))
      .subscribe((uploadDocumentObj: IUploadDocumentObj) => {
        if (!CommonUtils.isVoidObj(uploadDocumentObj)) {
          const formData: FormData = CommonUtils.checkAndGet(uploadDocumentObj, 'formData', null);
          const url: string = CommonUtils.checkAndGet(uploadDocumentObj, 'url', null);
          const headers: HttpHeaders = CommonUtils.checkAndGet(uploadDocumentObj, 'headers', null);
          this.uploadDocument(url, formData, headers);
        }
      })
  }

  createForm() {
    switch (this.operationId) {
      case '_VAGG':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(payment_form_template, payment_form_validators);
        break;
      case '_RISPA':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(partial_redeem_form_template, partial_redeem_form_validators);
        break;
      case '_RISTO':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(total_redeem_form_template, total_redeem_form_validators);
        break;
      case '_VCBMU':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(bank_account_update_form_template, bank_account_update_form_validators);
        break;
      case '_VPRFR':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(frequency_premium_change_form_template, frequency_premium_change_form_validators);
        break;
      case '_SCOPZ':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(liquidation_maturity_form_template, liquidation_maturity_form_validators);
        break;
      case '_VBESC':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(liquidation_maturity_form_template, liquidation_maturity_form_validators);
        break;
      case '_VRECP':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(address_change_form_template, address_change_form_validators);
        break;
      case '_SIMOR':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(claim_notification_form_template, claim_notification_form_validators);
        break;
      case '_VCONT':
        this.firstStepForm = FormUtils.initFormGroupFromTemplate(contractor_variation_form_template, contractor_variation_form_validators);
        this.searchForm = FormUtils.initFormGroupFromTemplate(subject_form_template, subject_form_validators);
        this.contractorAddressForm = FormUtils.initFormGroupFromTemplate(address_change_form_template, address_change_form_validators);
        break;
      case '_SWIT':
        if (!MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
          // caso Switch per prodotti Multisoluzione e Unit (switch con percentuali fisse)
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(single_step_branch_form_template, single_step_branch_form_validators);
        } else {
          // caso Switch per prodotti Multistrategia (switch con importi modificabili)
          this.firstStepForm = FormUtils.initFormGroupFromTemplate(divestment_form_template, divestment_form_validators);
          this.secondStepForm = FormUtils.initFormGroupFromTemplate(investment_form_template, investment_form_validators);
        }
        break;
      default:
        this.firstStepForm = new FormGroup({ '': new FormControl('') });
        break;
    }
    if (this.canChangeNDG) {
      this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(ndg_variation_form_template, ndg_variation_form_validators);
    }
    LoggerService.logInfo(this.constructor.name, 'createForm', { form: this.firstStepForm });
  }

  get productConstraints(): IProductConstraint[] {
    if (this._policyService.operationsConstraints && this.operationId && this._policyService.operationsConstraints[this.operationId]) {
      return this._policyService.operationsConstraints[this.operationId];
    }
    return null;
  }

  get operationConstraints(): IOperationConstraint[] {
    const roles: IOperationConstraint[] = [];
    if (this.productConstraints) {
      Object.values(this.productConstraints).forEach(element => {
        roles.push(element.role);
      });
    }
    return roles;
  }

  get showConstraintsInfoMessage(): boolean {
    return this.operationConstraints && this.operationConstraints.some((constraint: IOperationConstraint) => constraint.state && !constraint.constraint);
  }

  get additionalPaymentQuestionnaireCondition(): boolean {
    if (this.operationId === '_VAGG') {
      let amount = this.firstStepForm?.get('amount')?.value;
      amount = amount?.replace(/\./g, '');
      amount = amount?.replace(',', '.');
      return parseFloat(amount) >= MIN_VAGG_AMOUNT_FOR_QUESTIONNAIRE
    }
    return true;
  }

  get currentBankAccount(): string {
    let bankAccount: string = CommonUtils.checkAndGet(this._policyService.policyDetail, 'policyValue.codeRapporto', null);
    if (bankAccount) {
      bankAccount = bankAccount.replace(/\./g, '');
    }
    return bankAccount;
  }

  get questionnaireIsPresent(): boolean {
    return this.questionnaire
      && this.questionnaire.questions
      && this.questionnaire.questions.length > 0
      && this.additionalPaymentQuestionnaireCondition
      && this.operationId !== '_SIMOR';
  }

  get canChangeNDG(): boolean {
    return OPERATIONS_CHANGE_NDG.includes(this.operationId) &&
      (this._policyService.isLegalSubject || this.customerHasTutor);
  }

  get operationId(): string {
    return ['_SWITC', '_SWITR'].includes(this._policyService.operationId) ? '_SWIT' : this._policyService.operationId;
  }

  get policyId(): string {
    return this._policyService.policyId;
  }

  get productCode(): string {
    const code = CommonUtils.checkAndGet(this._policyService, 'policyDetail.summary.productCode', '');
    return code;
  }

  get lineCode(): string {
    const code = CommonUtils.checkAndGet(this._policyService, 'policyDetail.policyExtraInfo.lineCode', '');
    return code;
  }

  get currentRisk(): string {
    const code = CommonUtils.checkAndGet(this._policyService, 'policyDetail.summary.currentRisk', '');
    return code;
  }

  get operationTitle(): string {
    return CommonUtils.getOperationTitle(this.operationId, this.operationsNamesList);
  }

  get canViewStepper(): boolean {
    // TODO gestire rientro in operazione inviata (sola lettura)
    // return this._policyService.operations.some((operation: IPolicyOperation) => operation?.operationCode === this._policyService.operationId);
    return true;
  }

  get isSingleStepOperation(): boolean {
    if (this.operationId === '_SWIT') {
      if (CommonUtils.arrayInclude(MULTISOLUTION_PRODUCTS, this.productCode) || CommonUtils.arrayInclude(UNIT_PRODUCTS, this.productCode)) {
        return true;
      }
      return false;
    }
    return true;
  }

  get totalSwitchInvestment(): number {
    return this.branchSwitchInvestmentComponent.totalInvestmentAmount;
  }

  get hasDocsToDownload(): boolean {
    return this.documentsList && this.documentsList.length > 0 && this.documentsList.some(document => !document.isDownloaded && document.providedFromCompany);
  }

  get hasDocsToUpload(): boolean {
    return this.documentsList && this.documentsList.some(document => !document.providedFromCompany && document.isMandatory && !document.isUploaded);
  }

  get isQuestionnaireFormValid(): boolean {
    const keys = this.questionnaireFormKeys.filter(x => !x.hidden);
    const isAnyControlInvalid = keys.some(key => {
      const control = this.questionnaireForm.get(key?.controlName);
      return control ? control.invalid : false;
    })
    return !isAnyControlInvalid;
  }

  get hasNoFirstStep(): boolean {
    return OPERATINS_WITHOUT_CONFIRM_MODAL.includes(this.operationId);
  }

  get isReadOnly(): boolean {
    return this.operationStatus !== EDashboardStatus.DRAFT ||
      this.hasNoWriteAbilitation;
  }

  get isDraft(): boolean {
    return this.operationStatus === EDashboardStatus.DRAFT;
  }

  get isDocumentPending(): boolean {
    return this.operationStatus === EDashboardStatus.TO_UPLOAD;
  }

  get isAlreadySubmitted(): boolean {
    return this.operationStatus !== EDashboardStatus.DRAFT
      && this.operationStatus !== EDashboardStatus.TO_UPLOAD
  }

  get operationWithFunds(): boolean {
    return CommonUtils.arrayInclude(ALL_PRODUCTS_WITH_FUNDS, this.productCode);
  }

  get isCancelOperation(): boolean {
    return CANCEL_OPERATIONS.includes(this.operationId);
  }

  get isFirstStepActive(): boolean {
    if (this.isCancelOperation) {
      return this.cancelFirstStepActive;
    }
    return true;
  }

  get hasNoWriteAbilitation(): boolean {
    return this._authService.hasNoWriteAbilitation(this._policyService.policyType);
  }

  get isHelpDeskAccount(): boolean {
    return this._authService.isHelpDeskAccount(this._policyService.policyType) ;
  }

  get isSimulatedOperation(): boolean {
    return this.isHelpDeskAccount && this.simulateOperation;
  }

  get isWriteDisabled(): boolean {
    return (this.hasNoWriteAbilitation && !this.isSimulatedOperation) || [EDashboardStatus.TO_UPLOAD, EDashboardStatus.COMPLETED].includes(this.operationStatus as EDashboardStatus);
  }

  get confirmOperationDisabled(): boolean {
    return !this.isQuestionnaireFormValid || (this.hasNoWriteAbilitation && this.operationStatus === EDashboardStatus.DRAFT);
  }

  get canOperateToday(): boolean {
    return this._policyService.canOperateToday;
  }

  next(caller: TOperationStep) {
    switch (caller) {
      case EOperationStep.NDG_VARIATION:
        if (this.isDraft) {
          this.updateDraft();
        }
        this.stepper.next();
        break;
      case EOperationStep.FIRST_STEP:
        if (this.isWriteDisabled && !this.isCancelOperation) {
          this.stepper.next();
        } else if ((MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode]) && this.getOperationId() === '_SWIT')) {
          this.clearAssetsAmount();
          this.updateDraft();
          this.stepper.next();
        } else {
          if (!this.validateConstraints()) {
            return;
          }
          this.checkOperationAuthCode();
        }
        break;
      case EOperationStep.ADDITIONAL_STEP:
        if ((this.isReadOnly && !this.isHelpDeskAccount && !this.isCancelOperation)) {
          this.stepper.next();
        } else {
          if (!this.validateConstraints()) {
            return;
          }
          this.checkOperationAuthCode();
        }
        break;
      case EOperationStep.QUESTIONNAIRE:
        if (this.isReadOnly && !this.isHelpDeskAccount) {
          this.stepper.next()
        } else {
          this.updateDraft();
          this.openConfirmModal();
        }
        break;
      case EOperationStep.DOWNLOAD_DOC:
        this.stepper.next();
        break;
      case EOperationStep.NAVIGATE_POLICY:
        this._policyService.refreshPolicyDetail(true);
        this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        break;
      case EOperationStep.UPLOAD_DOC:
        if (this.isDocumentPending) {
          this.finalizeOperation();
        }
        break;
    }
  }

  previous() {
    this.stepper.previous();
  }

  clearAssetsAmount(): void {
    if (this.policyAssets) {
      this.policyAssets.forEach((asset: IPolicyAsset) => {
        asset.amount = '0';
      });
    }
    if (this.secondStepForm) {
      this.secondStepForm.get('amount').setValue('0');
    }
  }

  checkOperationAuthCode(): void {
    if (['_RISPA', '_RISTO'].includes(this.operationId) && this.firstStepForm) {
      this.checkAuthCode();
    }
    else {
      this.checkConsultancy();
    }
  }

  checkAuthCode(): void {
    this._spinnerService.show();
    const code: string = this.firstStepForm.get('authCode').value;
    this._athoraService.checkAuthCode(code, this.operationId, this._policyService.contractNumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'checkAuthCode', { response });
          if (response) {
            this.checkConsultancy();
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'checkAuthCode', { error });
          this._spinnerService.hide();
          const message: string = CommonUtils.checkAndGet(error, 'error.error.message', '');
          this._alertService.openErrorMessage(message, 'checkAuthCode', error);
        }
      }
      )
  }

  checkConsultancy(): void {
    if (this.operationId !== '_VAGG') {
      this.manageConsultancyResponse();
      return;
    }
    this._spinnerService.show();
    const importo: string = this.retrieveImportoForConsultancy();
    const ndgTutoreODelegato: string = this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined;
    let codiceLineaCompagnia: string[] = [];
    let controvaloreLineaCompagnia: string[] = [];
    const assetsToUse: IPolicyAsset[] = this.policyAssets.filter((asset: IPolicyAsset) => {
       return asset.amount && asset.amount !== '0' && asset.amount !== '0.00' && asset.amount !== '0,00';});
    if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode]) && ['_SWIT', '_SWITC', '_SWITR'].includes(this.getOperationId())) {
      const divestmentsToToUse: IPolicyAsset[] = this.funds.filter((asset: IPolicyAsset) => {
       return asset.amount && asset.amount !== '0' && asset.amount !== '0.00' && asset.amount !== '0,00';});
      assetsToUse.forEach(asset => {
        codiceLineaCompagnia.push(asset.fundCode);
        controvaloreLineaCompagnia.push( asset.fundAmount);
      })
      divestmentsToToUse.forEach(asset => {
        codiceLineaCompagnia.push(asset.fundCode);
        controvaloreLineaCompagnia.push('-' + asset.fundAmount);
      })
    } else if (MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
      codiceLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.fundCode});
      controvaloreLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.amount});
    } else {
      codiceLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.lineCode});
      controvaloreLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.amount});
    }

    this._athoraService.checkConsultancy(this.policyId, this.operationId, importo, ndgTutoreODelegato, codiceLineaCompagnia, controvaloreLineaCompagnia)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'checkConsultancy', { response });
          const resp = CommonUtils.checkAndGet(response, 'consultancy', null);
          if (resp) {
            this.manageConsultancyResponse();
          } else {
            this._alertService.openErrorMessage('Consulenza non trovata per Rapp/NDG', 'checkConsultancy');
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'checkConsultancy', { error });
          this._spinnerService.hide();
          this._alertService.openErrorMessage('Errore in fase di verifica della consulenza', 'checkConsultancy', error);
        }
      }
      )
  }

  manageConsultancyResponse(): void {
    if (this.questionnaireIsPresent) {
      this.updateDraft();
      this.stepper.next();
    } else if (CANCEL_OPERATIONS.includes(this.operationId)) {
      this.confirmCancelOperation();
    } else if (['_INPAG', '_RIAPU'].includes(this.operationId)) {
      this.updateDraft();
      if (this.isHelpDeskAccount) {
        this.openHelpDeskAccountModal();
        return;
      } else {
        this.confirmOperation();
      }
    } else {
      this.updateDraft();
      this.openConfirmModal();
    }
  }

  retrieveImportoForConsultancy(): string {
    if (this.operationId === '_VAGG') {
      return this.firstStepForm?.get('amount')?.value;
    }
    return null;
  }

  openTutorModal(): Observable<any> {
    return this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione",
        text: "Il contraente è un soggetto tutelato/assistito?",
        modalSize: 'modal-box-small text-center',
        buttons: [NO_BUTTON, YES_BUTTON]
      },
      disableClose: true
    })
    .afterClosed()
    .pipe(
      take(1),
      switchMap(outcome => {
        if (outcome) {
          this.customerHasTutor = outcome === EModalOutput.YES;
          this._spinnerService.show();
        }
        if (this.customerHasTutor) {
          this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(ndg_variation_form_template, ndg_variation_form_validators);
          return this._policyService.retrieveNdgList(this._policyService.contractNumber);
        } else {
          return of(null);
        }
      })
    );
  }

  openConstraintsModal(): void {
    let customText: string = '<ul>';
    if (this.productConstraints) {
      this.productConstraints.forEach((constraint: IProductConstraint) => {
        if (constraint.role.state && !constraint.role.constraint) {
          customText += '<li>' + constraint.role.message + ' (' + constraint.code + ')' + '</li>';
        }
      });
      customText += '</ul>';
      this._dialog.open(BasicModalComponent, {
        data: {
          title: "Attenzione:",
          text: customText,
          modalSize: 'modal-box-small',
          buttons: [CLOSE_BUTTON]
        },
        disableClose: true
      })
        .afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          LoggerService.logInfo(this.constructor.name, 'openConstraintsModal - close modal');
        })
    }
  }

  openOperationErrorModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: this.operationErrorDescription,
        modalSize: 'modal-box-small',
        buttons: [CLOSE_BUTTON]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        LoggerService.logInfo(this.constructor.name, 'openOperationErrorModal - close modal');
      })
  }

  openConfirmModal() {
    if (this.isHelpDeskAccount) {
      this.openHelpDeskAccountModal();
      return;
    }
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione",
        text: "Procedere con la conferma dell'operazione?",
        modalSize: 'modal-box-small text-center',
        buttons: [
          CLOSE_BUTTON,
          CONFIRM_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.CONFIRM) {
          this.confirmOperation();
        }
      })
  }

  openHelpDeskAccountModal() {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione",
        text: "Simulazione completata. Non è possibile procedere agli step successivi.",
        modalSize: 'modal-box-small text-center',
        buttons: [
          BACK_BUTTON,
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        LoggerService.logInfo(this.constructor.name, 'openHelpDeskAccountModal');
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  confirmCancelOperation(): void {
    this._spinnerService.show();
    const body: any = this.getPayloadForOperation();
    if (this.isCancelOperation) {
      body.movementId = this.movementId;
    }
    let operationId = this.getOperationId();
    this._athoraService.confirmOperation(body, operationId)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: response => {
          if (response) {
            this.movementId = CommonUtils.checkAndGet(response, 'movementId', null);
            localStorage.setItem('movementId', this.movementId);
            this.disableForms();
            this.manageStepper();
            LoggerService.logInfo(this.constructor.name, 'confirmCancelOperation', response);
            this.operationStatus = EDashboardStatus.TO_UPLOAD;
            if (this.isCancelOperation) {
              this.cancelFirstStepActive = false;
              this.cancelDocsInfo = CommonUtils.checkAndGet(response, 'documents', null);
              if (this.cancelDocsInfo) {
                this.cancelDocsInfo.forEach(doc => {
                  this.retrieveCancelDocument(doc);
                })
              }
            }
            this.stepper.next();
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'confirmCancelOperation', error);
          this._alertService.openErrorMessage("Errore in fase di conferma dell'operazione", 'confirmCancelOperation', error);
          this._spinnerService.hide();
        }
      })
  }

  confirmOperation(): void {
    this._spinnerService.show();
    const body: any = this.getPayloadForOperation();
    body.questionnaires = this.getQuestionnairesObj();
    let operationId = this.getOperationId();
    if (operationId === '_SWIT') {
      operationId = this.getMultistrategySwitchCode();
    }
    this._athoraService.confirmOperation(body, operationId)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((response: any) => {
          if (response?.statusCode === 202) {
            return this.startPollingForOperationStatus();
          }
          return of(response);
        })
      )
      .subscribe({
        next: (response: IDraft | 'TIMEOUT' | Error)  => {
          if (response && !(response instanceof Error)) {
            LoggerService.logInfo(this.constructor.name, 'confirmOperation', response);
            this.manageAsyncOperationResponse(response);
          } else {
            LoggerService.logError(this.constructor.name, 'confirmOperation', response);
            this._alertService.openErrorMessage("Errore in fase di conferma dell'operazione", 'confirmOperation', response);
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'confirmOperation', error);
          if (!this.isCancelOperation && !['_INPAG', '_RIAPU', '_SIMOR', '_VBENE'].includes(this.operationId)) {
            let stepperIndex = this.stepper.selectedIndex;
            if (this.questionnaireIsPresent) {
              stepperIndex = stepperIndex - 1;
            }
            this.updateDraft(EDashboardStatus.DRAFT, stepperIndex);
          }
          this._alertService.openErrorMessage("Errore in fase di conferma dell'operazione", 'confirmOperation', error, true);
          this._spinnerService.hide();
        }
      })
  }

  startPollingForOperationStatus(): Observable<any> {
    // Emette il draft ogni 6s finché è PENDING, oppure 'TIMEOUT' dopo 30s
    const polling$ = timer(0, 6000).pipe(
      switchMap(() => this._policyService.getDraft(null, false)),
      takeWhile((draft: IDraft) => draft && draft.operationState == EDashboardStatus.PENDING, true),
      last(undefined, undefined)
    );
    const timeout$ = timer(30000).pipe(
      switchMap(() => of('TIMEOUT'))
    );
    return race(polling$, timeout$);
  }

  manageAsyncOperationResponse(response: IDraft | 'TIMEOUT' | null): void {
    if (!response) {
      this._alertService.openErrorMessage("Errore in fase di conferma dell'operazione", 'confirmOperation', response);
    } else if (response === 'TIMEOUT') {
      this.openWaitingOperationStatusModal();
    } else {
      if (response.operationState === EDashboardStatus.DRAFT) {
        // operazione respinta lato Compagnia
        this.operationHasError = CommonUtils.checkAndGet(response, 'hasErrored', null);
        this.operationErrorDescription = this._alertService.parseAsyncOperationError(CommonUtils.checkAndGet(response, 'latestError', null));
        this._alertService.openErrorMessage(response.latestError, 'confirmOperation', response, true);
        return;
      } else if (response.operationState === EDashboardStatus.TO_UPLOAD) {
        // operazione andata a buon fine --> procedo sullo step di download dei documenti
        this.operationStatus = CommonUtils.checkAndGet(response, 'operationState', null);
        this.movementId = CommonUtils.checkAndGet(response, 'movementId', null);
        localStorage.setItem('movementId', this.movementId);
        this.disableForms();
        this.manageStepper();
        this.stepper.next();
      }
    }
    return;
  }

  getOperationId(): string {
    if (this.operationId !== '_SWIT') { return this.operationId; }
    if (MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) { return '_SWITR'; }
    if (UNIT_PRODUCTS.includes(EProductType[this.productCode])) { return '_SWITC'; }
    if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) { return '_SWIT'; }
  }

  getMultistrategySwitchCode(): '_SWITR' | '_SWITC' {
    if (this.funds && this.policyAssets) {
      const divestmentRamoI: IPolicyAsset = this.funds.find((fund: IPolicyAsset) => (fund.description === FONDO_GESTIONE_SEPARATA_LABEL) && parseFloat(String(fund.amount)?.replace(',', '.')) > 0);
      const investmentRamoI: IPolicyAsset = this.policyAssets.find((fund: IPolicyAsset) => (fund.attributeDescription === FONDO_GESTIONE_SEPARATA_LABEL) && parseFloat(String(fund.amount)?.replace(',', '.')) > 0);
      return (divestmentRamoI || investmentRamoI) ? '_SWITR' : '_SWITC';
    }
  }

  retrieveNdgList(): void {
    this._spinnerService.show();
    this._policyService.retrieveNdgList(this._policyService.contractNumber)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveNdgList', response);
          const collegamenti = response?.["ns2:listaCollegamenti"]?.["ns2:collegamenti"]
          const collegamentiAsArray = Array.isArray(collegamenti) ? collegamenti : [collegamenti]

          this.ndgVariationList = collegamentiAsArray.filter(c => {
              return COD_COLLEGAMENTI_ATTIVI_AMMESSI.includes(c?.['ns2:codiceCollegamento'])
          });
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveNdgList', error);
          this._alertService.openErrorMessage('', 'retrieveNdgList', error);
          this._spinnerService.hide();
        }
      });
  }

  retrieveCountries(): void {
    this._spinnerService.show();
    this._athoraService.retrieveCountries()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveCountries', { response });
          if (response) {
            this.countriesList = response.map(x => ({
              key: x.countryBDICode,
              value: x.countryDescription
            }));
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveProvinces', { error });
          this._alertService.openErrorMessage('Errore nel recupero della lista delle nazioni', 'retrieveProvinces', error);
          this._spinnerService.hide();
        }
      });
  }

  retrieveProvinces(): void {
    this._spinnerService.show();
    this._athoraService.retrieveProvinces()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveProvinces', { response });
          if (response) {
            this.provincesList = response.map(x => ({
              key: x.provinceCode,
              value: x.provinceDescription
            }));
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveProvinces', { error });
          this._alertService.openErrorMessage('Errore nel recupero della lista delle province', 'retrieveProvinces', error);
          this._spinnerService.hide();
        }
      });
  }

  retrieveCities(provinceCode: string): void {
    this._spinnerService.show();
    this._policyService.retrieveCities(provinceCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveCities', { response });
          if (response) {
            this.citiesList = response.map(x => ({
              key: x.cityName,
              value: x.cityName
            }));
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveCities', { error });
          this._alertService.openErrorMessage('Errore nel recupero della lista delle città', 'retrieveCities', error);
          this._spinnerService.hide();
        }
      });
  }

  retrieveDocuments(): void {
    this._spinnerService.show();
    let operationId = this.getOperationId();
    if (operationId === '_SWIT') {
      operationId = this.getMultistrategySwitchCode();
    }
    this._policyService.retrieveUploadDocuments(this.policyId, operationId, this.movementId)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveDocuments', { response });
          this.errorRetrievingDocs = false;
          this.documentsList = response.map(doc => ({ ...doc, isDownloaded: doc?.isDownloaded || doc?.userDownloaded }));
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveDocuments', { error });
          this.errorRetrievingDocs = true;
          this._spinnerService.hide();
          this._alertService.openErrorMessage(ERR_DOC_RETRIEVE_MESSAGE, 'retrieveDocuments', error);
        }
      }
      )
  }

  // recupera il documento per le sole operazioni di cancellazione
  retrieveCancelDocument(document: any): void {
    this._spinnerService.show();
    this._policyService.retrieveCancelDocuments(this.policyId, document?.codeInd, this.movementId)
      .pipe(takeUntil(this.destroy$)).subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveDocuments', { response });
          if (CommonUtils.checkAndGet(response, 'state', null) === 'KO') {
            this._alertService.openErrorMessage(ERR_DOC_RETRIEVE_MESSAGE, 'retrieveCancelDocument');
            this.errorRetrievingDocs = true;
          } else {
            const doc: ICancelDocument = {
              contentBuffer: CommonUtils.checkAndGet(response, 'contentBuffer', null),
              contentType: CommonUtils.checkAndGet(response, 'contentType', null),
              descrizioneDocumento: document?.description,
              isDownloaded: false,
              providedFromCompany: true
            }
            this.documentsList = [doc];
            this.errorRetrievingDocs = false;
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveDocuments', { error });
          this._spinnerService.hide();
          this._alertService.openErrorMessage(ERR_DOC_RETRIEVE_MESSAGE, 'retrieveCancelDocument', error);
        }
      })
  }

  startPolling(document: IDocument): void {
    const documentId = document?.codeInd;
    const operationId = this.getOperationId();
    this._policyService.startPolling(documentId, operationId, this.movementId, this.policyId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: HttpResponse<ICompanyDocumentResponse>) => {
          LoggerService.logInfo(this.constructor.name, 'startPolling', { response });
          if (response.status === 200) {
            this.downloadDocument({ ...document, S3DownloadInfo: CommonUtils.checkAndGet(response, 'body.S3DownloadUrl', null) });
          } else if (response.status > 400) {
            this.documentsList.forEach(doc => {
              if (doc?.descrizioneDocumento === document?.descrizioneDocumento) {
                doc.isDownloaded = false;
                doc.isDownloading = false;
              }
            });
            this.documentsList = [...this.documentsList];
            LoggerService.logError(this.constructor.name, 'startPolling', { response });
            this._alertService.openErrorMessage(ERROR_DOWNLOADING_DOC_MESSAGE, 'startPolling', response);
          }
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'startPolling', { error });
          this._alertService.openErrorMessage(ERROR_DOWNLOADING_DOC_MESSAGE, 'startPolling', error);
        }
      });
  }

  downloadDocument(document: IDocument): void {
    LoggerService.logInfo(this.constructor.name, 'downloadDocument', { document });
    if (document && document?.S3DownloadInfo?.downloadUrl) {
      this._policyService.downloadDocument(document?.S3DownloadInfo?.downloadUrl)
        .pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: Blob) => {
            LoggerService.logInfo(this.constructor.name, 'downloadDocument', { response });
            if (response) {
              this.manageDownloadedDoc(response, document);
            }
          },
          error: error => {
            LoggerService.logError(this.constructor.name, 'downloadDocument', { error });
            this._alertService.openErrorMessage(ERROR_DOWNLOADING_DOC_MESSAGE, 'retrieveDocuments', error);
          }
        });
    }
  }

  manageDownloadedDoc(blob: Blob, doc: IDocument): void {
    const url = window.URL.createObjectURL(blob); // Crea un URL per il Blob
    const a = document.createElement('a'); // Crea un elemento <a> per avviare il download
    a.href = url;
    a.download = doc?.S3DownloadInfo?.fileName + '.' + doc?.S3DownloadInfo?.fileFormat; // Setta il nome del file
    document.body.appendChild(a);
    a.click();  // Simula un click per avviare il download
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.documentsList.forEach(document => {
      if (document?.descrizioneDocumento === doc?.descrizioneDocumento) {
        document.isDownloaded = true;
        document.isDownloading = false;
      }
    });
    this.documentsList = [...this.documentsList];
    this.setDownloadedDoc({
      policyNumber: this.policyId,
      movementId: this.movementId,
      documentId: doc.codeInd
    });
  }

  setDownloadedDoc(body: any): void {
    this._spinnerService.show();
    this._policyService.setDownloadedDoc(body)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'setDownloadedDoc', { response });
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'setDownloadedDoc', { error });
          this._alertService.openErrorMessage('Errore', 'setDownloadedDoc', error);
          this._spinnerService.hide();
        }
      });
  }

  manageCancelDoc(doc: ICancelDocument): void {
    // decodifica Base64 in una stringa di byte
    const byteCharacters = atob(doc?.contentBuffer);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    // Crea un Blob a partire dall'array di byte
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob); // Crea un URL per il Blob
    const a = document.createElement('a'); // Crea un elemento <a> per avviare il download
    a.href = url;
    a.download = doc?.descrizioneDocumento + '.pdf'; // Setta il nome del file
    document.body.appendChild(a);
    a.click();  // Simula un click per avviare il download
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.documentsList.forEach(document => {
      if (document?.descrizioneDocumento === doc?.descrizioneDocumento) {
        document.isDownloaded = true;
      }
    });
    this.documentsList = [...this.documentsList];
  }

  uploadDocument(url: string, body: FormData, headers: HttpHeaders): void {
    LoggerService.logInfo(this.constructor.name, 'uploadDocument', { url: url, body: body, headers: headers });
    if (url && body) {
      this._spinnerService.show();
      this._policyService.uploadDocument(url, body, headers)
        .pipe(takeUntil(this.destroy$)).subscribe({
          next: response => {
            LoggerService.logInfo(this.constructor.name, 'uploadDocument', { response });
            this._spinnerService.hide();
            this.retrieveDocuments();
          },
          error: error => {
            LoggerService.logError(this.constructor.name, 'uploadDocument', { error });
            this._alertService.openErrorMessage('Errore in fase di caricamento del documento', 'uploadDocument', error);
            this._spinnerService.hide();
          }
        });
    }
  }

  onContractorSearch(ndg: string): void {
    LoggerService.logInfo(this.constructor.name, 'onContractorSearch');
    this._spinnerService.show();
    forkJoin({
      subjectResponse: this._policyService.retrieveNdgList(this._policyService.contractNumber, ndg),
      bankAccountsResponse: this._policyService.retrieveIbanList(this._policyService.contractNumber, ndg)
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: result => {
          LoggerService.logInfo(this.constructor.name, 'onContractorSearch', { result });
          if (result?.subjectResponse && result?.subjectResponse?.['ns2:dettaglioAnagrafico']) {
            this.searchedSubject = result?.subjectResponse['ns2:dettaglioAnagrafico'];
          }
          if (result?.bankAccountsResponse && result?.bankAccountsResponse?.length > 0) {
            this.ibanList = result?.bankAccountsResponse;
          }
          const newContractorType: string = this.searchedSubject['ns2:naturaGiuridica'];
          if (newContractorType === 'PF') {
            this.questionnaire = this.retrievedQuestionnaires.find(questionnaire => questionnaire.questionnaireCode.includes('PF'));
          }
          else {
            this.questionnaire = this.retrievedQuestionnaires.find(questionnaire => questionnaire.questionnaireCode.includes('PG'));
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'onContractorSearch', { error });
          this._spinnerService.hide();
          this._alertService.openErrorMessage('Errore nel recupero dei dati', 'onContractorSearch', error);
        }
      })
  }

  onContractorReset(): void {
    this.searchForm.reset();
    this.firstStepForm.reset();
    this.contractorAddressForm = FormUtils.initFormGroupFromTemplate(address_change_form_template, address_change_form_validators);
    this.searchedSubject = null;
  }

  onSubjectSelection(subject: IAnagrafica): void {
    LoggerService.logInfo(this.constructor.name, 'onSubjectSelection', subject);
    this.searchedSubject = subject;
  }

  disableForms(): void {
    if (this.firstStepForm) {
      this.firstStepForm.disable();
    }
    if (this.searchForm) {
      this.searchForm.disable();
    }
    if (this.questionnaireForm) {
      this.questionnaireForm.disable();
    }
    if (this.contractorAddressForm) {
      this.contractorAddressForm.disable();
    }
    if (this.ndgVariationForm && this.canChangeNDG) {
      this.ndgVariationForm.disable();
    }
  }

  getPayloadForOperation(): any {
    let body: any;
    switch (this.operationId) {
      case '_VAGG':
        body = this.getBodyVersamentoAggiuntivo();
        break;
      case '_SWIT':
        body = this.getBodySwitch();
        break;
      case '_RISTO':
        body = this.getBodyRiscattoTotale();
        break;
      case '_RISPA':
        body = this.getBodyRiscattoParziale();
        break;
      case '_INPAG':
        body = this.getBodySospensionePagamenti();
        break;
      case '_RIAPU':
        body = this.getBodyRiattivazionePagamenti();
        break;
      case '_SCOPZ':
      case '_VBESC':
        body = this.getBodyLiquidazioneScadenza();
        break;
      case '_VCBMU':
        body = this.getBodyVariazioneModPagamento();
        break;
      case '_VPRFR':
        body = this.getBodyVariazionePremioPeriodicita();
        break;
      case '_VCONT':
        body = this.getBodyVariazioneContraenza();
        break;
      case '_VRECP':
        body = this.getBodyVariazioneRecapito();
        break;
      case '_VBENE':
        body = this.getBodyVariazioneBeneficiari();
        break;
      case '_SIMOR':
        body = this.getBodyComunicazioneSinistro();
        break;
      case '_ARIST':
      case '_ARISP':
      case '_ANAPP':
        body = this.getBodyAnnulloOperazione();
        break;
      default:
        break;
    }
    return {
      ...body,
      contractNumber: this._policyService.contractNumber
    };
  }

  getAnswerType(question: IQuestion): EFormType {
    if (question.answerValues.length === 2 && question.answerValues[0].includes('true')) {
      return EFormType.RADIO;
    } else if (question.answerValues.length > 1) {
      return EFormType.SELECT;
    } else if (question.answerValues.length === 1 && question.answerValues[0].includes('text')) {
      return EFormType.INPUT;
    }
    return null;
  }

  getQuestionnaireFormKeys() {
    if (this.questionnaire && this.questionnaire.questions.length > 0) {
      const keys: IFormKey[] = [];
      this.questionnaire.questions.forEach(item => {
        const type = this.getAnswerType(item);
        const obj: IFormKey = {
          id: item.questionCode,
          controlName: item.questionCode,
          label: item.questionDescription,
          type: type,
          options: type === EFormType.SELECT ? item.answerValues.map(x => ({ key: x, value: x })) : [],
          readonly: item.isHidden,
          defaultValue: item.defaultAnswer,
          isInternal: item.isInternal,
        }
        keys.push(obj);
      });
      const template = keys.reduce((a, b) => {
        const value = b.defaultValue ?
          (b.type === EFormType.RADIO ? ERadioValue[b.defaultValue.toUpperCase()] : (b.defaultValue)) : null;
        a[b.controlName] = value;
        return a;
      }, {});
      const validators = keys.reduce((a, b) => {
        a[b.controlName] = [Validators.required];
        return a;
      }, {});
      LoggerService.logInfo(this.constructor.name, 'getFormKeys', { keys, template, validators });
      this.questionnaireForm = FormUtils.initFormGroupFromTemplate(template, validators);
      this.questionnaireFormKeys = keys;
      // CF lookup logic moved to QuestionnaireComponent for reusability
    }
  }

  getQuestionnairesObj(): IQuestionnaireAnswers[] {
    if (this.questionnaire && this.additionalPaymentQuestionnaireCondition) {
      if (this.operationId === '_SIMOR' && this.questionnairesArray) {
        const questionnairesToReturn: IQuestionnaireAnswers[] = [];
        this.questionnairesArray.forEach(element => {
          const questionnaire: IQuestionnaireAnswers = AthoraPayloadUtils.formatQuestionnaireAnswers(element.questionnaireCode, this.questionnaireFormKeys, element.questionnaireForm, element.fiscalCode);
          questionnairesToReturn.push(questionnaire);
        });
        return questionnairesToReturn;
      } else {
        const fiscalCode = this.operationId === '_SCOPZ' ?
          CommonUtils.checkAndGet(this._policyService, 'policyDetail.policyHolder.taxOrVatCode', null) :
          CommonUtils.checkAndGet(this._policyService, 'policyDetail.insured.taxOrVatCode', '');
        const questionnaire = AthoraPayloadUtils.formatQuestionnaireAnswers(this.questionnaire?.questionnaireCode, this.questionnaireFormKeys, this.questionnaireForm, fiscalCode);
        return [questionnaire];
      }
    }
    return [];
  }

  onViewSubject(key: IFormKey) {
    const subject = this.newLiquidationSubjects[key.controlName];
    this._dialog.open(SubjectPfInsertFormComponent, {
      data: { ...subject.rawFormOutcome },
      minWidth: '70vw',
      minHeight: '55vh',
    });
  }

  onDeleteSubject(key: IFormKey) {
    const { [key.controlName]: removed, ...rest } = this.newLiquidationSubjects;
    this.newLiquidationSubjects = rest;
  }

  onLiquidationSubjectsChange(subjects: any) {
    this.newLiquidationSubjects = subjects;
  }

  retrieveFrequencies(): void {
    this._spinnerService.show();
    this._athoraService.retrieveFrequencies(this.operationId, this._policyService.productCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveFrequencies', { response });
          this.frequencies = response;
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveFrequencies', { error });
          this._alertService.openErrorMessage('Errore nel recupero delle frequenze dei pagamenti', 'retrieveFrequencies', error);
          this._spinnerService.hide();
        }
      })
  }

  retrieveIbanList(ndg?: string): void {
    this._spinnerService.show();
    this._policyService.retrieveIbanList(this._policyService.contractNumber, ndg)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'retrieveIbanList', response);
          this.ibanList = response;
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'retrieveIbanList', error);
          this._alertService.openErrorMessage('Errore nel recupero delle coordinate bancarie', 'retrieveIbanList', error);
          this._spinnerService.hide();
        }
      })
  }

  isStepValid(operationId: string, caller?: string): boolean {
    if ([EOperationStep.FIRST_STEP, EOperationStep.QUESTIONNAIRE].includes(caller as EOperationStep) && this.isWriteDisabled && this.isDraft) {
      return false;
    }
    if (this.firstStepForm.disabled && !MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
      return true;
    }
    const isFormValid = () => this.firstStepForm && this.firstStepForm.valid;
    const isContractorAddressFormValid = () => this.contractorAddressForm && this.contractorAddressForm.valid;
    const isIbanValid = () => this.firstStepForm.controls['iban'].value !== 0;
    const isAmountValid = () => parseFloat(this.firstStepForm.controls['amount'].value) > 0;
    const arePolicyFundsValid = () => this.funds && this.funds.length > 0 && this.funds.every(fund => {
      const amount = parseFloat(fund.amount);
      let fundAmount = fund?.fundAmount?.split('.').join('');
      fundAmount = fundAmount?.replace(',', '.');
      return amount >= 0 && amount <= parseFloat(fundAmount);
    });
    const arePolicyAssetsAmountsValid = () => {
      let divestmentAmount = this.firstStepForm ? this.firstStepForm.get('amount').value : '0';
      divestmentAmount = divestmentAmount.replace(/\./g, '');
      divestmentAmount = divestmentAmount.replace(',', '.');
      let investmentsAmount = this.secondStepForm ? this.secondStepForm.get('amount').value : '0';
      investmentsAmount = investmentsAmount.replace(/\./g, '');
      investmentsAmount = investmentsAmount.replace(',', '.');
      return parseFloat(divestmentAmount) === parseFloat(investmentsAmount);
    };
    const areBeneficiariesValid = () => {
      const total = this.beneficiariesList.reduce((acc, beneficiary) =>
            acc + (beneficiary.toBeDeleted ? 0 : (beneficiary.quote ? parseFloat(beneficiary.quote?.replace(',', '.')) : 100)), 0).toFixed(2);
      return this.beneficiariesList && this.beneficiariesList.length > 0 && Number(total) === 100;
    }
    switch (operationId) {
        case '_VAGG':
            return isFormValid() && isAmountValid() && isIbanValid();
        case '_RISPA':
          if (MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
            return isFormValid() && isIbanValid();
          } else {
            return (this.firstStepForm.disabled || isFormValid()) && isIbanValid() && (this.operationWithFunds ? arePolicyFundsValid() : true);
          }
        case '_RISTO':
          return isFormValid() && isIbanValid();
        case '_VCONT':
          return isFormValid() && isIbanValid() && (this.firstStepForm.get('addressType')?.value === 'address' ? isContractorAddressFormValid() : true);
        case '_INPAG':
        case '_RIAPU':
            return true;
        case '_SWIT':
          if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
            if (caller === EOperationStep.ADDITIONAL_STEP) {
              return arePolicyAssetsAmountsValid();
            } else {
              return arePolicyFundsValid() && isAmountValid();
            }
          } else {
            return isFormValid();
          }
        case '_VBENE':
            return areBeneficiariesValid() &&
                this.beneficiariesList.some(x => x.isNewBeneficiary && !x.toBeDeleted);
        case '_SIMOR':
            return areBeneficiariesValid() &&
                this.questionnairesArray &&
                this.questionnairesArray.length === this.beneficiariesList.length &&
                isFormValid();
        case '_VCBMU':
          return isFormValid() && isIbanValid();
        default:
            return isFormValid();
    }
  }

  emittedFunds(funds): void {
    LoggerService.logInfo(this.constructor.name, 'emittedFunds', funds);
    this.funds = funds;
  }

  validateConstraints(): boolean {
    let isValid: boolean = true;
    if (this.productConstraints) {
      this.productConstraints.forEach((productConstraint: IProductConstraint) => {
        if (!productConstraint.role.state) {
          isValid = false;
        }
        const code: string = productConstraint.code;
        if (productConstraint.role.constraint) {
          productConstraint.role.constraint.forEach((constraint: IConstraint) => {
            if (!this.checkConstraintRule(constraint, code)) {
              isValid = false;
            }
          })
        }
      });
    }
    return isValid;
  }

  checkConstraintRule(constraint: IConstraint, code: string): boolean {
    const operator = constraint?.operator;
    const constraintValue = Number(constraint?.values);
    let formValue = null;
    if (this.policyAssets && this.policyAssets.length > 0) {
      const asset = this.policyAssets.find(asset => asset.fundCode === code);
      if (asset) {
        formValue = asset.amount?.split('.').join('');
        formValue = formValue?.replace(',', '.');
        formValue = parseFloat(formValue);
      } else {
        return true;
      }
    } else {
      formValue = parseFloat(this.firstStepForm?.get('amount').value.replace(',', '.'));
    }
    let check: boolean = true;
    let message: string = CONSTRAINT_MESSAGE_1;
    if (operator && constraintValue && formValue && !isNaN(constraintValue)) {
      switch (operator) {
        case '>=':
          message += CONSTRAINT_GREATER_OR_EQUAL;
          check = formValue >= constraintValue;
          break;
        case '<=':
          message += CONSTRAINT_LESSER_OR_EQUAL;
          check = formValue <= constraintValue;
          break;
        case '>':
          message += CONSTRAINT_GREATER;
          check = formValue > constraintValue;
          break;
        case '<':
          message += CONSTRAINT_LESSER;
          check = formValue < constraintValue;
          break;
        case '==':
          message += CONSTRAINT_EQUAL;
          check = formValue == constraintValue;
          break;
        default:
          check = false;
      }
      message += constraintValue;
    }
    if (!check) {
      this._alertService.openErrorMessage(message, 'checkConstraintRule');
    }
    return check;
  }

  getBodyVersamentoAggiuntivo(): IVersamentoAggiuntivoRequest {
    const ibanValue: string = this.firstStepForm.controls['iban'].value;
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
    const ndgTutoreODelegato: string = this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined;

    const assetsToUse: IPolicyAsset[] = this.policyAssets.filter((asset: IPolicyAsset) => {
      return asset.amount && asset.amount !== '0' && asset.amount !== '0.00' && asset.amount !== '0,00';});

    let codiceLineaCompagnia:string[];
    let controvaloreLineaCompagnia:string[];

    if (MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
      codiceLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.fundCode});
      controvaloreLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.amount});
    } else {
      codiceLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.lineCode});
      controvaloreLineaCompagnia = assetsToUse.map((asset: any ) => { return asset.amount});
    }

    const body: IVersamentoAggiuntivoRequest = {
      policyNumber: this._policyService.policyId,
      ibanVersamentoAggiuntivo: AthoraPayloadUtils.formatIBANString(ibanObj),
      numeroRapporto: AthoraPayloadUtils.formatCCString(ibanObj),
      ndgTutoreODelegato,
      codiceLineaCompagnia,
      controvaloreLineaCompagnia
    }
    if (this.operationWithFunds && this.policyAssets.length > 0) {
      if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
        const lifeInvestment: ILifeFund[] = [];
        this.policyAssets.forEach((asset: IPolicyAsset) => {
          const attributeKey: string = asset.attributeKey;
          let assetAmount = asset?.amount?.replace('.', '').replace(',', '.');

          const assetAmountAsFloat = parseFloat(assetAmount);

          if (body[attributeKey]) {
            body[attributeKey] = (parseFloat(body[attributeKey]) + assetAmountAsFloat).toString();
          } else {
            body[attributeKey] = assetAmountAsFloat.toString();
          }

          if (!asset.fundCode.startsWith('V')) {
            lifeInvestment.push({
              fundCode: asset.lineCode,
              fundAmount: assetAmount
            });
          }
        });
        body.lifeInvestments = lifeInvestment;
      } else {
        this.policyAssets.forEach(asset => {
          const assetAmount = asset?.amount?.split('.').join('');
          body[asset.attributeKey] = assetAmount?.toString().replace(',', '.');
        });
      }
    } else {
      body.importoPremio = this.firstStepForm.controls['amount'].value.replace(',', '.');
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyVersamentoAggiuntivo', body);
    return body;
  }

  getBodySwitch(): ISwitchRequest | ISwitchRamiRequest {
    let body: any = null;


    if (MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
      let codiceLineaCompagnia: string[] = [];
      let controvaloreLineaCompagnia: string[] = [];

      //Ramo scelto
      codiceLineaCompagnia.push(
        this.policyAssets.find((asset:any) =>{
          return asset.lineCode === this.firstStepForm.controls['line'].value;
        }).fundCode)

      // Ramo di provenienza
      codiceLineaCompagnia.push(this._policyService.policyDetail.summary.currentRisk)

      const consultancyAmount = parseFloat(CommonUtils.checkAndGet(this._policyService.policyDetail, 'policyValue.insuredAmount', null)).toFixed(2).replace(/\./g, ',')

      controvaloreLineaCompagnia.push(consultancyAmount)
      controvaloreLineaCompagnia.push('-'+ consultancyAmount)


      body = {  // ISwitchRamiRequest
        policyNumber: this._policyService.policyId,
        allocazioneRami: this.firstStepForm.controls['line'].value,
        ndgTutoreODelegato: this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined,
        codiceLineaCompagnia,
        controvaloreLineaCompagnia,
        consultancyAmount
      }
    } else if (UNIT_PRODUCTS.includes(EProductType[this.productCode])) {
      const lifeInvestment: ILifeFund = {
        fundCode: this.firstStepForm.controls['line'].value,
        fundAmount: this._policyService.policyDetail.policyValue.insuredAmount
      };
      const lifeDisinvestment: ILifeFund = {
        fundCode: this._policyService.policyDetail.policyExtraInfo.lineCode,
        fundAmount: this._policyService.policyDetail.policyValue.insuredAmount
      };

      const codiceLineaCompagnia: string[] = [];
      const controvaloreLineaCompagnia: string[] = [];

      controvaloreLineaCompagnia.push( lifeInvestment.fundAmount.replace('.', ','));
      codiceLineaCompagnia.push(lifeInvestment.fundCode);

      controvaloreLineaCompagnia.push('-' + lifeDisinvestment.fundAmount.replace('.', ','));
      codiceLineaCompagnia.push(lifeDisinvestment.fundCode);

      body = {  // ISwitchRequest
        policyNumber: this._policyService.policyId,
        lifeInvestments: [lifeInvestment],
        lifeDisinvestments: [lifeDisinvestment],
        ndgTutoreODelegato: this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined,
        consultancyAmount: lifeInvestment.fundAmount,
        codiceLineaCompagnia,
        controvaloreLineaCompagnia
      }
    } else {
      // caso Multistrategia
      const lifeInvestment: ILifeFund[] = [];
      const lifeDivestments: ILifeFund[] = [];
      this.policyAssets.forEach((fund: IPolicyAsset) => {
        let fundAmount = fund.amount?.replace(/\./g, '');
        fundAmount = fundAmount?.replace(',', '.');
        lifeInvestment.push({
          fundCode: fund.lineCode,
          fundAmount: fundAmount
        });
      });
      this.funds.forEach((fund: IPolicyAsset) => {
        let fundAmount = fund.amount?.replace(/\./g, '');
        fundAmount = fundAmount?.replace(',', '.');
        lifeDivestments.push({
          fundCode: fund.fundCode,
          fundAmount: fundAmount
        });
      });
      let codiceLineaCompagnia: string[] = [];
      let controvaloreLineaCompagnia: string[] = [];
      body = {
        policyNumber: this._policyService.policyId,
        lifeInvestments: lifeInvestment,
        lifeDisinvestments: lifeDivestments,
        ndgTutoreODelegato: this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined
      }
      lifeInvestment?.forEach(investment => {
        codiceLineaCompagnia.push( investment.fundAmount);
        controvaloreLineaCompagnia.push(investment.fundCode);
      });
      lifeDivestments?.forEach(divestment => {
        codiceLineaCompagnia.push('-' + divestment.fundAmount);
        controvaloreLineaCompagnia.push(divestment.fundCode);
      });
      body.codiceLineaCompagnia = codiceLineaCompagnia;
      body.controvaloreLineaCompagnia = controvaloreLineaCompagnia;


      body.consultancyAmount = lifeInvestment.reduce((accumulatore, valore: ILifeFund) => {
          const numberValue = valore.fundAmount.replace(/\./g, '').replace(',', '.')
          return accumulatore + parseFloat(numberValue);}, 0).toFixed(2).toString().replace(/\./g, ',')
    }

    LoggerService.logInfo(this.constructor.name, 'getBodySwitch', body);
    return body;
  }

  getBodyRiscattoTotale(): IRiscattoTotaleRequest {
    const ibanValue: string = this.firstStepForm.controls['iban'].value;
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
    const body: IRiscattoTotaleRequest = {
      policyNumber: this._policyService.policyId,
      payments: AthoraPayloadUtils.getPaymentObject(this._policyService.accountHolder, ibanObj),
      authorizationCode: this.firstStepForm.controls['authCode'].value,
      consultancyAmount: null

    }
    if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
      body.ndgTutoreODelegato = this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined;
      let codiceLineaCompagnia: string[] = [];
      let controvaloreLineaCompagnia: string[] = [];
      this.funds?.forEach(fund => {
        if (fund) {
          codiceLineaCompagnia.push(fund.fundCode);
          controvaloreLineaCompagnia.push(fund.fundAmount);
        }
      })

      body.codiceLineaCompagnia = codiceLineaCompagnia;
      body.controvaloreLineaCompagnia = controvaloreLineaCompagnia;
    }

    body.consultancyAmount = body.controvaloreLineaCompagnia &&  body.controvaloreLineaCompagnia.length ?
      (body.controvaloreLineaCompagnia.reduce((accumulatore, valore) => {
        const numberValue = valore.replace(/\./g, '').replace(',', '.')
        return accumulatore + parseFloat(numberValue);}, 0)).toFixed(2).toString().replace(/\./g, ','): parseFloat(CommonUtils.checkAndGet(this._policyService.policyDetail, 'policyValue.insuredAmount', null)).toFixed(2).replace(/\./g, ',');

    if (this.newLiquidationSubjects && Object.keys(this.newLiquidationSubjects).length) {
      body.liquidationSubjects = this.mapLiquidationSubjects(this.newLiquidationSubjects);
    }

    LoggerService.logInfo(this.constructor.name, 'getBodyRiscattoTotale', body);
    return body;
  }

  getBodyRiscattoParziale(): IRiscattoParzialeRequest {
    const ibanValue: string = this.firstStepForm.controls['iban'].value;
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
    const body: IRiscattoParzialeRequest = {
      policyNumber: this._policyService.policyId,
      payments: AthoraPayloadUtils.getPaymentObject(this._policyService.accountHolder, ibanObj),
      authorizationCode: this.firstStepForm.controls['authCode'].value,

      consultancyAmount: null,
      ndgTutoreODelegato: this.searchedSubject && this.searchedSubject['ns2:ndg'] ? this.searchedSubject['ns2:ndg'] : undefined
    }
    if (this.operationWithFunds && this.policyAssets.length > 0) {
      let codiceLineaCompagnia: string[] = [];
      let controvaloreLineaCompagnia: string[] = [];

      if (!MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
        this.funds.filter(asset => asset.amount !== '0,00')?.forEach(fund => {
          const asset = this.policyAssets?.find(asset => asset.lineCode === fund.fundCode);
          const fundAmount = fund?.amount?.split('.').join('');
          if (asset) {
            body[asset.attributeKey] = fundAmount?.toString().replace(',', '.');
            codiceLineaCompagnia.push(asset.lineCode);
            controvaloreLineaCompagnia.push(fundAmount);
          } else {
            body.importoRiscatto = fundAmount?.toString().replace(',', '.');
          }
        })

      } else {

        this.policyAssets.forEach(asset => {
          const assetAmount = asset?.amount?.split('.').join('');
          body[asset.attributeKey] = assetAmount?.toString().replace(',', '.');
          codiceLineaCompagnia.push(asset.lineCode);
          controvaloreLineaCompagnia.push(asset.amount);
        });
      }

      body.codiceLineaCompagnia = codiceLineaCompagnia;
      body.controvaloreLineaCompagnia = controvaloreLineaCompagnia;
    } else {
      body.importoRiscatto = this.firstStepForm.controls['amount'].value.replace(',', '.');
    }

    body.consultancyAmount = body.controvaloreLineaCompagnia &&  body.controvaloreLineaCompagnia.length ?
      (body.controvaloreLineaCompagnia.reduce((accumulatore, valore) => {
        const numberValue = valore.replace(/\./g, '').replace(',', '.')
        return accumulatore + parseFloat(numberValue);}, 0)).toFixed(2).toString().replace(/\./g, ','):  body.importoRiscatto;

    if (MULTISTRATEGY_PRODUCTS.includes(EProductType[this.productCode])) {
      if (!body.importoRiscatto) {
        body.importoRiscatto = '0';
      }
    }

    if (this.newLiquidationSubjects && Object.keys(this.newLiquidationSubjects).length) {
      body.liquidationSubjects = this.mapLiquidationSubjects(this.newLiquidationSubjects);
    }

    LoggerService.logInfo(this.constructor.name, 'getBodyRiscattoParziale', body);
    return body;
  }

  getBodySospensionePagamenti(): ISospensionePagamentiRequest {
    const body: ISospensionePagamentiRequest = {
      policyNumber: this._policyService.policyId,
    }
    LoggerService.logInfo(this.constructor.name, 'getBodySospensionePagamenti', body);
    return body;
  }

  getBodyRiattivazionePagamenti(): IRiattivazionePagamentiRequest {
    const body: IRiattivazionePagamentiRequest = {
      policyNumber: this._policyService.policyId,
      frequency: CommonUtils.checkAndGet(this._policyService.policyDetail, 'summary.prizeType', null),
      importo: CommonUtils.checkAndGet(this._policyService.policyDetail, 'policyValue.paymentsList[0].paymentAmount', null)
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyRiattivazionePagamenti', body);
    return body;
  }

  getBodyLiquidazioneScadenza(): ILiquidazioneScadenzaRequest {
    const ibanValue: string = this.firstStepForm.controls['iban'].value;
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
    const body: ILiquidazioneScadenzaRequest = {
      policyNumber: this._policyService.policyId,
      payments: AthoraPayloadUtils.getPaymentObject(
        this._policyService.accountHolder,
        ibanObj
      ),
    };

    if (this.newLiquidationSubjects && Object.keys(this.newLiquidationSubjects).length) {
      body.liquidationSubjects = this.mapLiquidationSubjects(this.newLiquidationSubjects);
    }

    LoggerService.logInfo(this.constructor.name, 'getBodyLiquidazioneScadenza', body);
    return body;
  }

  getBodyVariazioneModPagamento(): IVariazioneModPagamentoRequest {
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === this.firstStepForm.controls['iban'].value.substring(10));
    const body: IVariazioneModPagamentoRequest = {
      policyNumber: this._policyService.policyId,
      accountHolder: this._policyService.accountHolder,
      iban: AthoraPayloadUtils.formatIBANString(ibanObj),
      numeroRapporto: AthoraPayloadUtils.formatCCString(ibanObj)
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyVariazioneModPagamento', body);
    return body;
  }

  getBodyVariazionePremioPeriodicita(): IVariazionePremioPeriodicitaRequest {
    const body: IVariazionePremioPeriodicitaRequest = {
      policyNumber: this._policyService.policyId,
      frequency: this.frequencies[this.firstStepForm.controls['frequency'].value] ?
        this.frequencies[this.firstStepForm.controls['frequency'].value] : CommonUtils.checkAndGet(this._policyService.policyDetail, 'summary.prizeType', null),
      importo: this.firstStepForm.controls['amount']?.value.toString().replace(',', '.')
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyVariazionePremioPeriodicita', body);
    return body;
  }

  getBodyAnnulloOperazione(): IAnnulloOperazione {
    const body: IAnnulloOperazione = {
      policyNumber: this._policyService.policyId
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyAnnulloOperazione', body);
    return body;
  }

  getBodyVariazioneContraenza(): IBodyVariazioneContraenza {
    const policyHolderFiscalCode: string = this.searchedSubject?.['ns2:codiceFiscale'];
    const shareCapital = this.firstStepForm.get('shareCapital') ? this.firstStepForm.get('shareCapital')?.value : null;
    const email = this.firstStepForm.get('email') ? this.firstStepForm.get('email')?.value : null;
    const subject = AthoraPayloadUtils.formatSubjectFromDettaglioBPER(this.searchedSubject, shareCapital);
    const address: IAddress = {
      country: this.contractorAddressForm?.get('country').value,
      place: this.contractorAddressForm?.get('place').value,
      province: this.contractorAddressForm?.get('province').value,
      postalCode: this.contractorAddressForm?.get('postalCode').value,
      toponym: this.contractorAddressForm?.get('toponym').value ?? '',
      address: this.contractorAddressForm?.get('address').value,
      addressNumber: this.contractorAddressForm?.get('addressNumber').value,
    }
    const ibanValue = this.firstStepForm.get('iban').value;
    const ibanObj: IIbanObject = this.ibanList.find(obj => obj?.numeroRapporto === ibanValue.substring(10));
    const body: IBodyVariazioneContraenza = {
      policyNumber: this.policyId,
      policyHolderFiscalCode: policyHolderFiscalCode,
      policyHolderEmail: email,
      subject: subject,
      ...(!email && {address: address}),
      policyHolderIban: AthoraPayloadUtils.formatIBANString(ibanObj)
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyVariazioneContraenza', { body });
    return body;
  }

  getBodyVariazioneRecapito(): IVariazioneRecapitoRequest {
    const body: IVariazioneRecapitoRequest = {
      policyNumber: this.policyId,
      address: {
        country: this.firstStepForm.get('country').value,
        place: this.firstStepForm.get('place').value,
        province: this.firstStepForm.get('province').value,
        postalCode: this.firstStepForm.get('postalCode').value,
        toponym: this.firstStepForm.get('toponym').value ?? '',
        address: this.firstStepForm.get('address').value,
        addressNumber: this.firstStepForm.get('addressNumber').value,
      }
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyVariazioneRecapito', { body });
    return body;
  }

  getBodyVariazioneBeneficiari(): IVariazioneBeneficiariRequest {
    const beneficiaries: IBeneficiary[] = AthoraPayloadUtils.formatBeneficariesFromBeneficiariesObject(this.beneficiariesList);
    const subjects: (ISubjectPersonaFisica | ISubjectPersonaGiuridica)[] = []
    this.beneficiariesList.forEach((beneficiary: IBeneficiaryObject) => {
      const formattedSubject = AthoraPayloadUtils.formatSubjectFromBeneficiaryObject(beneficiary);
      subjects.push(formattedSubject);
    });
    const body: IVariazioneBeneficiariRequest = {
      policyNumber: this.policyId,
      beneficiaries: beneficiaries,
      subjects: subjects?.filter(subject => subject !== null)
    };
    LoggerService.logInfo(this.constructor.name, 'getBodyVariazioneBeneficiari', body);
    return body;
  }

  getBodyComunicazioneSinistro(): IComunicazioneSinistroRequest {
    const subjects: (ISubjectPersonaFisica | ISubjectPersonaGiuridica)[] = [];
    const payments: IOperationPayment[] = [];
    this.beneficiariesList?.forEach((beneficiary: IBeneficiaryObject) => {
      const subject: ISubjectPersonaFisica | ISubjectPersonaGiuridica = AthoraPayloadUtils.formatSubjectFromBeneficiaryObject(beneficiary);
      subjects.push(subject);
      const paymentObject: IOperationPayment = {
        paymentMethod: 'Bonifico',
        iban: beneficiary.iban,
        beneficiaryFiscalCode: beneficiary.taxCode ?? beneficiary.vatCode,
        accountHolder: beneficiary.taxCode ?? beneficiary.vatCode,
      }
      payments.push(paymentObject);
    });
    const beneficiaries: IBeneficiary[] = AthoraPayloadUtils.formatBeneficariesFromBeneficiariesObject(this.beneficiariesList);

    const body: IComunicazioneSinistroRequest = {
      policyNumber: this.policyId,
      subjects: subjects,
      dataMorte: this.firstStepForm.get('deceaseDate').value,
      motivoSinistro: this.firstStepForm.get('deceaseCause').value,
      denunciante: this.firstStepForm.get('declarantSurname').value + ' ' + this.firstStepForm.get('declarantName').value,
      payments: payments,
      beneficiaries: beneficiaries,
      ...(Object.values(this.newLiquidationSubjects).length && {liquidationSubjects: this.mapLiquidationSubjects(this.newLiquidationSubjects)})
    }
    LoggerService.logInfo(this.constructor.name, 'getBodyComunicazioneSinistro', body);
    return body;
  }

  finalizeOperation(): void {
    LoggerService.logInfo(this.constructor.name, 'finalizeOperation');
    this._spinnerService.show();
    const operationId = this.getOperationId();
    this._policyService.finalizeOperation(this.policyId, operationId, this.movementId)
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => {
          return this._policyService.checkDocuments(this.policyId, operationId, this.productCode);
        })
      ).subscribe({
        next: response => {
          this.openFinalizedOperationModel();
          LoggerService.logInfo(this.constructor.name, 'finalizeOperation', { response });
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'finalizeOperation', { error });
          this._alertService.openErrorMessage("Errore in fase di finalizzazione dell'operazione", 'finalizeOperation', error);
          this._spinnerService.hide();
        }
      })
  }

  openFinalizedOperationModel(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Operazione completata con successo!",
        text: "La tua operazione è stata inviata correttamente. Puoi tornare alla polizza per continuare con l'operatività.",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  openWaitingOperationStatusModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: "L'operazione sta richiedendo più tempo del previsto. Si prega di tornare alla polizza e di riprovare più tardi.",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  mapLiquidationSubjects(rawSubjects: any) {
    return Object.values(rawSubjects).map((subject: any) => subject.mappedOutcome);
  }

  retrieveDraftStatus(): Observable<boolean> {
    return this._policyService.getDraft(this.movementId, this.isSimulatedOperation).pipe(
      take(1),
      map((response: IDraft) => {
        if (response) {
          return response.operationState !== 'DRAFT';
        }
        return false;
      }),
      catchError((error: any) => {
        LoggerService.logError(this.constructor.name, 'retrieveDraftStatus', { error });
        this._alertService.openErrorMessage("Errore nel recupero dello stato della bozza", 'retrieveDraftStatus', error);
        return of(false);
      })
    );
  }

  openBackToPolicyModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: 'L\'operazione di "Switch" per polizze Multistrategia non è al momento disponibile sulla BPER Suite. Per procedere con l\'operatività manuale puoi scaricare i moduli dedicati nella sezione Menù - Documenti (in alto a sinistra) e inviarli tramite mail all\'indirizzo: assistenza@athora.com. Come da istruzioni operative inviare i moduli cartacei per posta interna.',
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  openBlockOperationModal(): void {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: "L'operazione sta richiedendo più tempo del previsto. Si prega di uscire e contattare l'assistenza.",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  patchFormsFromDraft(draft: IDraftItem) {
    LoggerService.logInfo(this.constructor.name, 'patchFormFromDraft', { draft });
    if (draft.firstStepForm && this.firstStepForm) {
      FormUtils.patchFormFromObject(draft.firstStepForm, this.firstStepForm);
    }
    if (draft.secondStepForm && this.secondStepForm) {
      FormUtils.patchFormFromObject(draft.secondStepForm, this.secondStepForm);
    }
    if (draft.ndgVariationForm) {
      this.ndgVariationForm = FormUtils.initFormGroupFromTemplate(ndg_variation_form_template, ndg_variation_form_validators);
      FormUtils.patchFormFromObject(draft.ndgVariationForm, this.ndgVariationForm);
    }
    if (draft.questionnaireForm && this.questionnaireForm) {
      FormUtils.patchFormFromObject(draft.questionnaireForm, this.questionnaireForm, false);
    }
    if (draft.contractorAddressForm && this.contractorAddressForm) {
      FormUtils.patchFormFromObject(draft.contractorAddressForm, this.contractorAddressForm);
    }
    if (this.isWriteDisabled) {
      this.disableForms();
    }
  }

  patchObjectsFromDraft(draft: IDraftItem): void {
    this.customerHasTutor = CommonUtils.checkAndGet(draft, 'customerHasTutor', null);
    // patch asset se l'operazione prevede dei fondi
    if (draft.assets && draft.assets.length > 0) {
      this.policyAssets = draft.assets;
    } else if (this.operationWithFunds) {
      this.loadAsset$.next(true);
    }
    // patch index dello stepper per atterrare sullo step da compilare
    if (draft.selectedIndex !== null) {
      this.selectedIndex = draft.selectedIndex;
      if (this.operationStatus === EDashboardStatus.DRAFT && draft.firstStepForm &&
        Object.keys(draft.firstStepForm).filter(key => !CommonUtils.isVoid(draft.firstStepForm?.[key])).length > 0 && this.questionnaireIsPresent && draft.selectedIndex === 0) {
          this.selectedIndex += 1;
      }
      if (draft.ndgVariationForm && this.operationStatus === EDashboardStatus.DRAFT && [0, 1].includes(draft.selectedIndex)
        && this.questionnaireIsPresent && Object.keys(draft.ndgVariationForm).filter(key => !CommonUtils.isVoid(draft.ndgVariationForm?.[key])).length > 0) {
        this.selectedIndex += 1;
      }
      if (this.operationStatus === EDashboardStatus.TO_UPLOAD) {
        this.selectedIndex += 1;
      }
      if ([EDashboardStatus.DOC_SENT, EDashboardStatus.COMPLETED].includes(this.operationStatus as EDashboardStatus)) {
        this.selectedIndex += 2;
      }
    }
    // patch soggetto cercato/tutore/rappresentante legale
    if (draft.searchedSubject) {
      this.searchedSubject = draft.searchedSubject;
    }
    // patch lista beneficiari
    if (draft.beneficiaries) {
      this.beneficiariesList = draft.beneficiaries;
    }
    if (draft.liquidationSubjects) {
      this.newLiquidationSubjects = draft.liquidationSubjects;
    }
    // patch questionari beneficiari (SIMOR)
    if (draft.questionnairesArray) {
      draft.questionnairesArray.forEach(questionnaireObj => {
        const obj: IFilledQuestionnaire = {
          fiscalCode: questionnaireObj.fiscalCode,
          questionnaireForm: FormUtils.initFormGroupFromTemplate(questionnaireObj.questionnaireForm),
          questionnaireCode: questionnaireObj.questionnaireCode
        };
        this.questionnairesArray.push(obj);
      });
    }
    // patch fondi
    if (draft.funds) {
      this.funds = draft.funds;
    }
  }

  openDraftErrorModal() {
    this._dialog.open(BasicModalComponent, {
      data: {
        title: "Attenzione!",
        text: "È presente una diversa operazione in bozza per la polizza corrente.",
        modalSize: 'modal-box-small align-items-center text-center',
        buttons: [
          BACK_TO_POLICY_BUTTON
        ]
      },
      disableClose: true
    })
      .afterClosed()
      .pipe(take(1))
      .subscribe(outcome => {
        if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
          this._policyService.refreshPolicyDetail(true);
          this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
        }
      })
  }

  openCannotOperateTodayErrorModal() {
      this._dialog.open(BasicModalComponent, {
        data: {
          title: "Attenzione!",
          text: "È presente un'operazione completata in data odierna per la polizza corrente.",
          modalSize: 'modal-box-small align-items-center text-center',
          buttons: [
            BACK_TO_POLICY_BUTTON
          ]
        },
        disableClose: true
      })
        .afterClosed()
        .pipe(take(1))
        .subscribe(outcome => {
          if (outcome === EModalOutput.BACK_TO_POLICY_BUTTON) {
            this._policyService.refreshPolicyDetail(true);
            this._router.navigate([`/policies/${this._policyService.contractNumber}`]);
          }
        })
    }

  updateDraft(state = EDashboardStatus.DRAFT, index = null) {
    if (this.isHelpDeskAccount) {
      // per gli account HD non deve essere possibile salvare nuove bozze
      return;
    }
    const draft: IDraftItem = {
      firstStepForm: this.firstStepForm?.getRawValue(),
      secondStepForm: this.secondStepForm?.getRawValue(),
      questionnaireForm: this.questionnaireForm?.getRawValue(),
      selectedIndex: index !== null ? index : this.stepper.selectedIndex,
      assets: this.policyAssets,
      funds: this.funds,
      ndgVariationForm: this.ndgVariationForm?.getRawValue(),
      searchedSubject: this.searchedSubject,
      contractorAddressForm: this.contractorAddressForm?.getRawValue(),
      beneficiaries: this.beneficiariesList,
      questionnairesArray: this.questionnairesArray?.map(obj => ({
        fiscalCode: obj.fiscalCode,
        questionnaireForm: obj.questionnaireForm?.getRawValue(),
        questionnaireCode: obj.questionnaireCode
      })),
      customerHasTutor: this.customerHasTutor,
      liquidationSubjects: this.newLiquidationSubjects
    }
    const encodedString = btoa(JSON.stringify(draft));
    LoggerService.logInfo(this.constructor.name, 'updateDraft', { draft, encodedString });
    this.operationStatus = state;
    this.saveDraft(encodedString);
  }

  saveDraft(draft: string) {
    if (this.isHelpDeskAccount) {
      // per gli account HD non deve essere possibile salvare nuove bozze
      return;
    }
    this._spinnerService.show();
    const operationId = this.getOperationId();
    this._policyService.saveDraft(draft, this.operationStatus, operationId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'saveDraft', { response });
          this.operationStatus = CommonUtils.checkAndGet(response, 'entity.operationState', null);
          this._dashboardService.triggerPendingOperations();
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'saveDraft', { error });
          this._alertService.openErrorMessage('', 'saveDraft', error);
          this._spinnerService.hide();
        }
      })
  }

  getDraft() {
    if (this.isCancelOperation) {
      this.loadingCompleted = true;
      return;
    }
    this._spinnerService.show();
    forkJoin({
      draftResponse: this._policyService.getDraft(this.movementId, this.isSimulatedOperation),
      questionnaireResponse: this._athoraService.getQuestionnaire(this.policyId, this.operationId)
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: x => {
          LoggerService.logInfo(this.constructor.name, 'getDraft', { x });
          if (x.questionnaireResponse && x.questionnaireResponse.length > 0) {
            if (!this._policyService.isLegalSubject) {
              this.questionnaire = x.questionnaireResponse.find(questionnaire => questionnaire.questionnaireCode.includes('PF'));
            }
            else {
              this.questionnaire = x.questionnaireResponse.find(questionnaire => questionnaire.questionnaireCode.includes('PG'));
            }
            this.retrievedQuestionnaires = CommonUtils.assign(x.questionnaireResponse);
            this.getQuestionnaireFormKeys();
          }
          if (x.draftResponse && x.draftResponse.draft && x.draftResponse.operationCode) {
            const check = x.draftResponse.operationCode.includes(this._policyService.operationId);
            if (check) {
              // CASO 1: response presente, operation code coincide
              try {
                const decodedString = atob(x.draftResponse.draft);
                const obj: IDraftItem = JSON.parse(decodedString);
                this.operationStatus = x.draftResponse.operationState;
                this.movementId = CommonUtils.checkAndGet(x.draftResponse, 'movementId', null);
                this.operationHasError = CommonUtils.checkAndGet(x.draftResponse, 'hasErrored', null);
                this.operationErrorDescription = this._alertService.parseAsyncOperationError(CommonUtils.checkAndGet(x.draftResponse, 'latestError', null));
                this.patchFormsFromDraft(obj);
                this.patchObjectsFromDraft(obj);
                if (this.isWriteDisabled) {
                  this.disableForms();
                }
                this.manageOperationObs(obj);
              } catch (e) {
                this._alertService.openErrorMessage('Errore nel recupero della bozza', 'getDraft');
                LoggerService.logError(this.constructor.name, 'getDraft', { e });
              }
            } else {
              // CASO 2: response presente, operation code non coincide
              this.openDraftErrorModal();
            }
          } else {
            // CASO 3: response nulla (non ci sono draft)
            if (!this.canOperateToday) {
              this.openCannotOperateTodayErrorModal();
              this._spinnerService.hide();
              return;
            }
            if (x.draftResponse.operationCode && x.draftResponse.operationCode !== this.getOperationId()) {
              this.openDraftErrorModal();
            } else {
              if (!x.draftResponse.operationCode) {
                this.saveDraft('');
              }
              if (x.draftResponse.operationState) {
                this.operationStatus = x.draftResponse.operationState;
              }
              this.beneficiariesList = this.operationId === '_SIMOR' ? [] : CommonUtils.checkAndGet(this._policyService, 'policyDetail.beneficiaries', null);
              if (this.isWriteDisabled) {
                this.disableForms();
              }
              if (this.operationWithFunds) {
                if (!MULTISOLUTION_PRODUCTS.includes(EProductType[this.productCode])) {
                  const policyFunds = CommonUtils.checkAndGet(this._policyService.policyDetail, 'policyValue.funds', null);
                  if (policyFunds) {
                    this.funds = policyFunds.map(fund => ({
                      fundCode: fund.code,
                      description: UNIT_PRODUCTS.includes(EProductType[this.productCode]) ? fund.lineName : fund.description,
                      fundAmount: Number(fund.fundAmount)?.toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }),
                      amount: '0',
                      percentage: fund.percentage
                    }));
                  }
                }
                this.loadAsset$.next(true);
              }
              this.manageOperationObs();
            }
          }
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'getDraft', { error });
          const status = CommonUtils.checkAndGet(error, 'status', null);
          if (status === 403) {
            this._alertService.openErrorMessage('Non è possibile operare su questa polizza', 'getDraft', error);
          } else {
            this._alertService.openErrorMessage('', 'getDraft', error);
          }
          this._spinnerService.hide();
        }
      })
  }

  manageOperationObs(obj?: IDraftItem) {
    // gestione recupero nome operazione
    let operationsNames$ : Observable<IOperationFilter[]> = this._dashboardService.retrieveOpDomain(CommonUtils.checkAndGet(this._policyService.policyDetail, 'summary.companyCode', null));
    // gestione recupero documenti
    let documents$: Observable<IDocument[]> = of(null);
    if (this.operationStatus && this.operationStatus !== EDashboardStatus.DRAFT) {
      let operationId = this.getOperationId();
      if (operationId === '_SWIT') {
        operationId = this.getMultistrategySwitchCode();
      }
      documents$ = this._policyService.retrieveUploadDocuments(this.policyId, operationId, this.movementId);
    }
    // gestione recupero frequenze
    let frequencies$: Observable<string[]> = of(null);
    if (OPERATIONS_WITH_FREQUENCY.includes(this.operationId)) {
      frequencies$ = this._athoraService.retrieveFrequencies(this.operationId, this.productCode);
    }
    // gestione recupero nazione, provincia e città
    let countries$: Observable<ICountriesObject[]> = of(null);
    let provinces$: Observable<IProvinceObject[]> = of(null);
    let cities$: Observable<ICityObject[]> = of(null);
    if (this.operationId === '_VRECP') {
      countries$ = this._athoraService.retrieveCountries();
      if (obj && obj.firstStepForm['province']) {
        provinces$ = this._athoraService.retrieveProvinces();
      }
      if (obj && obj.firstStepForm['place']) {
        cities$ = this._policyService.retrieveCities(obj.firstStepForm['province']);
      }
    }
    if (this.operationId === '_VCONT') {
      countries$ = this._athoraService.retrieveCountries();
      if (obj && obj.contractorAddressForm['province']) {
        provinces$ = this._athoraService.retrieveProvinces();
      }
      if (obj && obj.contractorAddressForm['place']) {
        cities$ = this._policyService.retrieveCities(obj.contractorAddressForm['province']);
      }
    }
    // gestione recupero tutore/legale rappresentante
    let ndg$: Observable<IAnagrafica[]> = of(null);
    let iban$: Observable<IIbanObject[]> = of(null);
    if (this.searchedSubject || this._policyService.isLegalSubject || this.customerHasTutor) {
      this.customerHasTutor = true;
      ndg$ = this._policyService.retrieveNdgList(this._policyService.contractNumber);
    }
    if (OPERATIONS_CHANGE_NDG.includes(this.operationId) && (!obj || !obj.searchedSubject) && !obj?.firstStepForm && !this._policyService.isLegalSubject && !this.customerHasTutor) {
      iban$ = this._policyService.retrieveIbanList(this._policyService.contractNumber);
      this._spinnerService.hide();
      this.openTutorModal()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: x => {
            this.updateDraft(EDashboardStatus.DRAFT, 0);
            ndg$ = of(x);
            this.manageOperationResponses(frequencies$, iban$, countries$, provinces$, cities$, ndg$, documents$, operationsNames$);
          },
          error: err => {
            LoggerService.logError(this.constructor.name, 'manageOperationObs', err);
          }
      })
    } else {
      // gestione recupero lista iban
      this._spinnerService.show();
      if (OPERATIONS_WITH_IBAN.includes(this.operationId) && !(this.operationId === '_VCONT' && this.operationStatus === null)) {
        let ndg: string;
        if (obj) {
          ndg = this.operationId === '_VCONT'
            ? this.searchedSubject['ns2:ndg']
            : this._policyService.ndg;
        } else {
          ndg = this._policyService.ndg;
        }
        iban$ = this._policyService.retrieveIbanList(this._policyService.contractNumber, ndg);
      }
      this.manageOperationResponses(frequencies$, iban$, countries$, provinces$, cities$, ndg$, documents$, operationsNames$);
    }
  }

  manageOperationResponses(
    frequencies$: Observable<string[]>,
    iban$: Observable<IIbanObject[]>,
    countries$: Observable<ICountriesObject[]>,
    provinces$: Observable<IProvinceObject[]>,
    cities$: Observable<ICityObject[]>,
    ndg$: Observable<IAnagrafica[]>,
    documents$: Observable<IDocument[]>,
    operationsNames$: Observable<IOperationFilter[]>
  ): void {
    forkJoin({
      frequenciesResponse: frequencies$,
      ibanResponse: iban$,
      countriesResponse: countries$,
      provincesResponse: provinces$,
      citiesResponse: cities$,
      ndgResponse: ndg$,
      documentsResponse: documents$,
      operationsNamesResponse: operationsNames$
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: x => {
          LoggerService.logInfo(this.constructor.name, 'manageOperationResponses', { x });
          if (x?.frequenciesResponse) {
            this.frequencies = x.frequenciesResponse;
          }
          if (x?.ibanResponse) {
            this.ibanList = x.ibanResponse;
          }
          if (x?.countriesResponse) {
            this.countriesList = x.countriesResponse.map(x => ({
                key: x.countryBDICode,
                value: x.countryDescription
              }));
          }
          if (x?.provincesResponse) {
            this.provincesList = x.provincesResponse.map(x => ({
              key: x.provinceCode,
              value: x.provinceDescription
            }));
          }
          if (x?.citiesResponse) {
            this.citiesList = x.citiesResponse.map(x => ({
              key: x.cityName,
              value: x.cityName
            }));
          }
          if (x?.ndgResponse) {
            const collegamenti = x?.ndgResponse?.["ns2:listaCollegamenti"]?.["ns2:collegamenti"]
            const collegamentiAsArray = Array.isArray(collegamenti) ? collegamenti : [collegamenti]
            this.ndgVariationList = collegamentiAsArray.filter(c => {
              return COD_COLLEGAMENTI_ATTIVI_AMMESSI.includes(c?.['ns2:codiceCollegamento'])
            });
          }
          if (x?.documentsResponse) {
            this.documentsList = x?.documentsResponse.map(doc => ({ ...doc, isDownloaded: doc?.isDownloaded || doc?.userDownloaded }));
          }
          if (x?.operationsNamesResponse) {
            this.operationsNamesList = x?.operationsNamesResponse;
          }
          this.loadingCompleted = true;
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'manageOperationResponses', { error });
          this._alertService.openErrorMessage('Errore nel recupero delle info delle operazioni', 'manageOperationResponses', error);
          this._spinnerService.hide();
        }
      })
  }

  deleteDraft() {
    this._spinnerService.show();
    this._policyService.deleteDraft()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'deleteDraft', { response });
          this._dashboardService.triggerPendingOperations();
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'deleteDraft', { error });
          this._alertService.openErrorMessage('', 'deleteDraft', error);
          this._spinnerService.hide();
        }
      })
  }

  watchDescribe() {
    combineLatest([
      this._policyService.detailLoadedObs,
      this.loadAsset$
    ])
      .pipe(
        filter(([a, b]) => a && b),
        takeUntil(this.destroy$)
      )
      .subscribe(([a, b]) => {
        LoggerService.logInfo(this.constructor.name, 'watchDescribe', { a, b });
        this.describeOperation();
      })
  }

  describeOperation() {
    this._spinnerService.show();
    const operationId = this.getOperationId();
    this._athoraService.describeOperation(operationId, this.productCode, this.currentRisk, this.lineCode)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          LoggerService.logInfo(this.constructor.name, 'describeOperation', { response });
          this.policyAssets = response.map(asset => ({ ...asset, amount: '0' }));
          this._spinnerService.hide();
        },
        error: error => {
          LoggerService.logError(this.constructor.name, 'describeOperation', { error });
          this._alertService.openErrorMessage("Errore nel recupero dei fondi", 'describeOperation', error);
          this._spinnerService.hide();
        }
      })
  }

  ngOnDestroy(): void {
    localStorage.removeItem('movementId');
    this._policyService.detailLoaded(null);
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
